import api from "./api";

const medicationService = {};
const medicationEndpoint = "/medications";

medicationService.getMedications = function (filter = {}) {
  return api
    .get(medicationEndpoint, { params: filter })
    .then(({ data }) => data);
};

export default medicationService;
